import React from "react";
import { Route, Switch } from "react-router-dom";

import Account from "containers/Account/Info/Account.js";
import Login from "containers/Account/Login/Login";
import Error from "containers/Account/Error/Error";
import Logout from "containers/Account/Logout/Logout";
import Payment from "containers/Template/Menu/Payment/Payment";
import Feeds from "containers/Feeds/Feeds";
import ChildrenList from "containers/Account/MyChildren/ChildrenList";
import AddChild from "containers/Account/MyChildren/AddChild";
import ProjectsHome from "containers/Projects/Home/ProjectsHome";
import ProjectDetails from "containers/Projects/Details/ProjectDetails";
import StartProjectStepOne from "containers/Projects/StartProject/Step_1/StartProjectStepOne";
import StartProjectStepTwo from "containers/Projects/StartProject/Step_2/StartProjectStepTwo";
import StartProjectStepThree from "containers/Projects/StartProject/Step_3/StartProjectStepThree";
import ProjectInvitation from "containers/Projects/ActiveProject/Step_0/ProjectInvitation";
import ActiveProjectChallenge1 from "containers/Projects/ActiveProject/Step_1/ActiveProjectChallenge1";
import ActiveProjectChallenge2 from "containers/Projects/ActiveProject/Step_2/ActiveProjectChallenge2";
import LearnNewSkill from "containers/Projects/ActiveProject/Step_3/LearnNewSkill/LearnNewSkill";
import DevelopNewHabit from "containers/Projects/ActiveProject/Step_3/DevelopNewHabit/DevelopNewHabit";
import RaiseYourVoice from "containers/Projects/ActiveProject/Step_3/RaiseYourVoice/RaiseYourVoice";
import Mobile_toolbar from "containers/Template/Header/Mobile/Mobile_toolbar";
import VolunteerTime from "containers/Projects/ActiveProject/Step_3/VolunteerTime/VolunteerTime";
import SpreadTheWord from "containers/Projects/ActiveProject/Step_3/SpreadTheWord/SpreadTheWord";
import SpotlightHome from "containers/Spotlight/SpotlightHome";
import GiveADonation from "containers/Projects/ActiveProject/Step_3/GiveADonation/GiveADonation";
import Fundraiser from "containers/Projects/ActiveProject/Step_3/Fundraiser/Fundraiser";
import ProjectComplete from "containers/Projects/ActiveProject/ProjectComplete/ProjectComplete";
import Skeleton from "containers/Skeleton";
import RegisterStepOne from "containers/Account/Register/RegisterStepOne.js";
import RegisterStepTwo from "containers/Account/Register/RegisterStepTwo.js";
import Believer from "containers/Account/Onboarding/Believer/Believer";
import Dream from "containers/Account/Onboarding/Dream/Dream";
import Cause from "containers/Account/Onboarding/Cause/Cause";
import Superpower from "containers/Account/Onboarding/Superpower/Superpower";
import FamilyAccount from "containers/Account/Onboarding/FamilyAccount/FamilyAccount";
import OnboardingChild from "containers/Account/Onboarding/Children/OnboardingChild";
import OnboardingGuardian from "containers/Account/Onboarding/Guardian/OnboardingGuardian";
import AddGuardian from "containers/Account/Onboarding/Guardian/AddGuardian";
import ActivateUser from "containers/Account/Register/ActivateUser";
import ResendActivation from "containers/Account/Register/ResendActivation";
import ForgotPassword from "containers/Account/Login/ForgotPassword";
import RegisterChildTemp from "containers/Account/Register/RegisterChildTemp";
import Misc from "containers/Template/Menu/Misc/Misc";
import GuardianManagement from "containers/Account/Onboarding/FamilyAccount/GuardianManagement";
import OnboardingGuardianInvatation from "./containers/Account/Onboarding/Guardian/OnboardingGuardianInvatation";
import FriendsHome from "./containers/Tribe/Friends/Home/FriendsHome";
import ProfilePicture from "containers/Account/Info/ProfilePicture";
import MarketComingSoon from "./containers/MarketComingSoon";
import BlockedUsers from "./containers/Tribe/Friends/BlockedUsers/BlockedUsers";
import GroupsHome from "./containers/Tribe/Groups/Home/GroupsHome";
import GroupForm from "./containers/Tribe/Groups/GroupForm/GroupForm";
import GroupProfileDetail from "containers/Tribe/Groups/GroupProfile/GroupProfileDetail";
import ManageChildTribeHome from "./containers/Tribe/Friends/ManageChildTribe/ManageChildTribeHome";
import UserProfile from "./containers/Tribe/Friends/UserDetail/UserProfile";
import ProjectDetails_new from "./containers/Projects/Details/ProjectDetails_new";
import ContentCreationSuite from "./containers/Content/CreationHome"
import BuildYourTeam from "./containers/Tribe/Friends/Home/BuildYourTeam";
import ProjectSummary from "./containers/Projects/Details/ProjectSummary";
import SinglePost from "containers/Feeds/SinglePost";

class BaseRouter extends React.Component {
  render() {
    switch (this.props.userState) {
      case "registered":
        return (
          <div>
            <Switch>
              <Route exact path="/" component={Feeds} />
              <Route exact path="/home" component={Feeds} />
              <Route exact path="/log-in" component={Feeds} />
              <Route exact path="/Account" component={Account} />
              <Route
                exact
                path="/Account/ProfilePicture"
                component={ProfilePicture}
              />
              <Route exact path="/Menu/Payment" component={Payment} />
              <Route exact path="/account" component={Account} />
              <Route exact path="/payments" component={Payment} />
              <Route
                exact
                path="/terms-and-conditions"
                render={(props) => <Misc {...props} slug="terms" />}
              />
              <Route
                exact
                path="/security-and-privacy"
                render={(props) => <Misc {...props} slug="privacy" />}
              />
              <Route
                exact
                path="/contact-us"
                render={(props) => <Misc {...props} slug="contact-us" />}
              />
              <Route
                exact
                path="/about-us"
                render={(props) => <Misc {...props} slug="about-us" />}
              />
              <Route exact path="/my-children-list" component={ChildrenList} />
              <Route exact path="/projects/" component={ProjectsHome} />
              <Route
                exact
                path="/onboarding-guardian-invatation"
                component={OnboardingGuardianInvatation}
              />
              <Route
                exact
                path="/projects/:slug/challenges"
                component={ProjectDetails}
              />
              <Route
                exact
                path="/projects/:slug"
                component={ProjectDetails_new}
              />
              <Route
                exact
                path="/projects/:slug/project-invitation/:inviterEmail"
                component={ProjectInvitation}
              />
              <Route
                exact
                path="/projects/:slug/active-project-challenge-1"
                component={ActiveProjectChallenge1}
              />
              <Route
                exact
                path="/projects/:slug/active-project-challenge-2"
                component={ActiveProjectChallenge2}
              />
              <Route
                exact
                path="/projects/:slug/learn-new-skill"
                component={LearnNewSkill}
              />
              <Route
                exact
                path="/projects/:slug/develop-new-habit"
                component={DevelopNewHabit}
              />
              <Route
                exact
                path="/projects/:slug/raise-your-voice"
                component={RaiseYourVoice}
              />
              <Route
                exact
                path="/projects/:slug/volunteer-time"
                component={VolunteerTime}
              />
              <Route
                exact
                path="/projects/:slug/start-project-step-one"
                component={StartProjectStepOne}
              />
              <Route
                exact
                path="/projects/:slug/start-project-step-two"
                component={StartProjectStepTwo}
              />
              <Route
                exact
                path="/projects/:slug/start-project-step-three"
                component={StartProjectStepThree}
              />
              <Route
                exact
                path="/projects/:slug/spread-the-word"
                component={SpreadTheWord}
              />
              <Route
                exact
                path="/projects/:slug/give-a-donation"
                component={GiveADonation}
              />
              <Route
                exact
                path="/projects/:slug/fundraise"
                component={Fundraiser}
              />
              <Route
                exact
                path="/projects/:slug/congratulations"
                component={ProjectComplete}
              />
              <Route
                exact
                path="/projects/project-summary/:slug"
                component={ProjectSummary}
              />
              <Route
                exact
                path="/profile/:type/:group_id/:group_name/new-member/:username"
                component={UserProfile}
              />
              <Route
                exact
                path="/profile/group-invite/:group_request_id/:type/:group_name/:group_id/:username/"
                component={UserProfile}
              />
              <Route
                exact
                path="/profile/group-review/:group_request_id/:type/:group_name/:group_id/:username/"
                component={UserProfile}
              />
              <Route
                exact
                path="/profile/:type/:request_id/:username"
                component={UserProfile}
              />
              <Route
                exact
                path="/profile/:type/:username"
                component={UserProfile}
              />
              {/*route for inviting new members to groups*/}
              <Route
                exact
                path="/profile/:child_username/:type/:request_id/:username"
                component={UserProfile}
              />
              <Route exact path="/add-child" component={AddChild} />
              <Route exact path="/mobile-toolbar" component={Mobile_toolbar} />
              <Route exact path="/spotlight" component={SpotlightHome} />
              <Route exact path="/skeleton" component={Skeleton} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/friends" component={FriendsHome} />
              <Route exact path="/blocked-users" component={BlockedUsers} />
              {/* <Route exact path= "/content-creation-suite" component={ContentCreationSuite} /> */}
              <Route
                exact
                path="/manage-child-tribe"
                component={ManageChildTribeHome}
              />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              {/*TODO: change when Market is done*/}
              <Route
                exact
                path="/market-coming-soon"
                component={MarketComingSoon}
              />
              {/* Group Routes */}
              <Route exact path="/groups" component={GroupsHome} />
              <Route
                exact
                path="/groups/start-new-group"
                component={GroupForm}
              />
              <Route
                exact
                path="/groups/edit-group-details/:groupId"
                component={GroupForm}
              />
              <Route
                exact
                path="/groups/:type/:group_id/:group_name"
                component={GroupProfileDetail}
              />
              <Route
                exact
                path="/groups/:child_username/:type/:group_id/:group_name/:invite_id"
                component={GroupProfileDetail}
              />
              <Route
                exact
                path="/guardian-management"
                component={GuardianManagement}
              />
              <Route
                exact
                path="/onboarding-add-guardian"
                component={OnboardingGuardian}
              />
              <Route exact path="/build-your-team" component={BuildYourTeam} />
              <Route
                exact
                path="/build-your-team/:groupId/"
                component={BuildYourTeam}
              />
              <Route exact path="/add-guardian" component={AddGuardian} />
              {/* <Route path="*" exact={true} component={Error} /> */}
              <Route exact path="/feeds/:postId" component={SinglePost} />
              <Route exact path="*" exact component={ProjectsHome} />
            </Switch>
          </div>
        );
      case "onboarding":
        return (
          <div>
            <Switch>
              <Route exact path="/log-in" component={Believer} />
              <Route exact path="/" component={Believer} />
              <Route exact path="/home" component={Believer} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/onboarding-believer" component={Believer} />
              <Route exact path="/onboarding-dream" component={Dream} />
              <Route
                exact
                path="/onboarding-superpower"
                component={Superpower}
              />
              <Route exact path="/onboarding-cause" component={Cause} />
              <Route
                exact
                path="/onboarding-family-account"
                component={FamilyAccount}
              />
              <Route
                exact
                path="/onboarding-add-child"
                component={OnboardingChild}
              />
              <Route
                exact
                path="/onboarding-add-guardian"
                component={OnboardingGuardian}
              />
              <Route path="*" exact={true} component={Error} />
            </Switch>
          </div>
        );
      default:
      case "unregistered":
        return (
          <div>
            <Switch>
              <Route
                exact
                path="/terms-and-conditions"
                render={(props) => <Misc {...props} slug="terms" />}
              />
              <Route
                exact
                path="/security-and-privacy"
                render={(props) => <Misc {...props} slug="privacy" />}
              />
              <Route
                exact
                path="/contact-us"
                render={(props) => <Misc {...props} slug="contact-us" />}
              />
              <Route
                exact
                path="/about-us"
                render={(props) => <Misc {...props} slug="about-us" />}
              />
              <Route
                exact
                path="/log-in"
                render={(props) => (
                  <Login {...props} appState={this.props.appState} />
                )}
              />
              <Route
                exact
                path="/home"
                component={() => {
                  window.location.href = "/log-in";
                  return null;
                }}
              />
              <Route exact path="/logout" component={Logout} />
              <Route
                exact
                path="/register-step-one"
                component={RegisterStepOne}
              />
              <Route
                exact
                path="/register-step-two"
                component={RegisterStepTwo}
              />
              <Route
                exact
                path="/register-step-three"
                component={RegisterChildTemp}
              />
              <Route exact path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/activate-user" component={ActivateUser} />
              <Route
                exact
                path="/resend-activation"
                component={ResendActivation}
              />
              <Route exact path="/error" component={Error} />
              <Route
                exact
                path="/login-success"
                component={() => {
                  window.location.href =
                    "https://get.katamundi.com/confirmation/";
                  return null;
                }}
              />
              <Route
                exact
                path="/"
                component={() => {
                  window.location.href = "/log-in";
                  return null;
                }}
              />
              <Route path="*" exact={true} component={Error} />
            </Switch>
          </div>
        );
    }
  }
}

export default BaseRouter;
